export default __webpack_public_path__ + "static/media/lp-sec05_ttl.45beda34.png";